/**
 * Fixed position of element relatively to parent Container
 */
export default class PositionStickyHorizontal {
  /**
   * constructor
   * if the browser supports css position: sticky. this function will exit
   * @param {object} [options]
   */
  constructor(options = {}) {
    this.config = {
      selector: {
        container: '[data-pos-sticky-container]',
        element: '[data-pos-sticky-x-element]',
      },
      modifier: 'position-sticky-horizontal',
      ...options,
    };
    this.containerList = document.querySelectorAll(this.config.selector.container);
    const prefix = ['', '-o-', '-webkit-', '-moz-', '-ms-'];
    const testCssSupport = document.head.style;
    for (let i = 0; i < prefix.length; i += 1) {
      testCssSupport.position = `${prefix[i]}sticky`;
    }
    if (!this.containerList.length || testCssSupport.position.length) {
      return;
    }
    this.adjustLeftPosition();
  }

  /**
   * Use translateX to adjust the left position of the sticky item.
   * Set a max-scroll width to prevent the scroll element breaking out of scroll container
   */
  adjustLeftPosition() {
    this.containerList.forEach((container) => {
      const maxScroll = container.scrollWidth;
      const elements = container.querySelectorAll(this.config.selector.element);
      container.addEventListener('scroll', () => {
        elements.forEach((elem) => {
          const element = elem;
          const scrollPosition = container.scrollLeft + element.offsetWidth;
          if (scrollPosition < maxScroll) {
            element.style.transform = `translateX(${container.scrollLeft}px)`;
          }
        });
      });
    });
  }
}
